module.exports = __webpack_public_path__ + "images/08-07@2x_444ec8ff.png";